import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { stopAudio } from "@/lib/sharedAudio";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import ResetPlayer from "@/components/ResetPlayer";
import { useResetLibrary } from "@/lib/resets";
import { primeBreath } from "@/lib/breathSound";

// "Need Xcelio now": pick the moment, and the closest of the six resets plays.
export default function ResetSheet({ open, onClose, autoContext, next }) {
  const navigate = useNavigate();
  const lib = useResetLibrary();
  const [contexts, setContexts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (open) api.get("/reset/contexts").then((r) => setContexts(r.data)).catch(() => {});
    if (!open) { setActive(null); stopAudio(); }
  }, [open]);

  const run = (ctx) => {
    const r = (lib || []).find((x) => x.id === ctx.reset);
    if (r) { primeBreath(); setActive(r); }
  };

  useEffect(() => {
    if (open && autoContext && contexts.length && lib && !active) {
      const c = contexts.find((x) => x.id === autoContext);
      if (c) run(c);
    }
  }, [open, autoContext, contexts, lib]); // eslint-disable-line react-hooks/exhaustive-deps

  if (open && active) {
    const go = next && { label: next.label, onGo: () => { stopAudio(); onClose(); navigate(next.route); } };
    return <ResetPlayer reset={active} onClose={onClose} next={go} />;
  }
  return (
    <Dialog open={open && !autoContext} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="reset-sheet">
        <VisuallyHidden><DialogTitle>Need Xcelio now</DialogTitle></VisuallyHidden>
        <div className="py-2">
          <p className="text-xs uppercase tracking-[0.2em] text-primary mb-2">A moment, before you go in</p>
          <h2 className="font-serif text-3xl mb-6">What are you walking into?</h2>
          <div className="grid gap-2">
            {contexts.map((c) => (
              <button key={c.id} onClick={() => run(c)} data-testid={`reset-${c.id}`}
                className="text-left px-4 py-3 rounded-xl border border-border hover:border-primary hover:bg-primary/5 transition-colors duration-300 text-sm">
                {c.label}
              </button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
